import React, { Suspense, lazy } from "react";

// Lazy load heavy components for better performance
export const LazySpotlightActivityCard = lazy(
  () => import("./SpotlightActivityCard"),
);
export const LazyVibeCheckCard = lazy(() => import("./VibeCheckCard"));
export const LazyVibeStream = lazy(() => import("./VibeStream"));
export const LazyActivityDetailModal = lazy(
  () => import("./ActivityDetailModal"),
);

// Loading fallback component
export const ComponentSkeleton: React.FC<{ height?: string }> = ({
  height = "h-32",
}) => (
  <div
    className={`bg-gray-200 ${height} rounded-2xl animate-pulse w-full`}
  ></div>
);

// Wrapper components with Suspense boundaries
export const SuspenseSpotlightCard: React.FC<any> = (props) => (
  <Suspense fallback={<ComponentSkeleton height="h-48" />}>
    <LazySpotlightActivityCard {...props} />
  </Suspense>
);

export const SuspenseVibeCard: React.FC<any> = (props) => (
  <Suspense fallback={<ComponentSkeleton />}>
    <LazyVibeCheckCard {...props} />
  </Suspense>
);

export const SuspenseVibeStream: React.FC<any> = (props) => (
  <Suspense fallback={<ComponentSkeleton height="h-16" />}>
    <LazyVibeStream {...props} />
  </Suspense>
);

export const SuspenseActivityModal: React.FC<any> = (props) => (
  <Suspense fallback={null}>
    <LazyActivityDetailModal {...props} />
  </Suspense>
);
